import { Pipe, PipeTransform } from '@angular/core';
import {DataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';

@Pipe({
    name: 'addCurrentAttributeToList'
})
export class AddCurrentAttributeToListPipe implements PipeTransform {

    transform(attributeList: DataAttribute[], selectedAttribute: DataAttribute): DataAttribute[] {
        let result = attributeList;
        if (selectedAttribute && selectedAttribute.propertyName) {
            const attrIsAlreadyAvilable = !!attributeList.find((attr: DataAttribute) =>
                attr.propertyName === selectedAttribute.propertyName);

            result = !attrIsAlreadyAvilable ? attributeList.concat([selectedAttribute]) : attributeList;
        }

        return result;
    }
}
